import store from '@/store'; // Adjust the path to your Vuex store as necessary
import _ from 'lodash'; // Make sure lodash is imported if you're using it

export function authMiddleware(to, from, next) {
  const publicRoutes = ['/login', '/customer', '/customer/forgot', '/customer/reset-password', '/customer/invitation', '/old-browser', '/maintenance', '/basket', '/punchout-only'];
  const loggedIn = _.get(store, 'state.account.loggedIn');
  const isAdminPath = to.path.startsWith('/admin');
  const isEvolveUser = _.get(store, 'state.account.session.account.isEvolveUser');
  const permissions = _.get(store, 'state.account.session.account.permissions', []);
  const isPunchoutSession = _.get(store, 'state.account.isPunchoutSession');
  const punchoutOnly = !isPunchoutSession && permissions.includes('punchoutOnly');

  // If the user is logged in
  if (loggedIn) {
    // Check if user is punchout-only and not in a punchout session
    // Don't redirect from login page to allow punchout session establishment
    if (punchoutOnly && to.path !== '/punchout-only' && to.path !== '/login') {
      return next('/punchout-only');
    }

    // If the user is not an evolve user and is trying to access admin paths
    if (!isEvolveUser && isAdminPath) {
      return next('/');
    }

    // Permission mapping
    const mapping = [
      { path: '/manpack', permission: 'canViewManpack' },
      { path: '/wearer-pack', permission: 'canViewManpack' },
      { path: '/catalogue', permission: 'canViewFullCatalogue' },
      { path: '/my-catalogue', permission: 'canViewMyCatalogue' },
      { path: '/employee-catalogue', permission: 'canViewUserCatalogue' },
      { path: '/order-history', permission: 'viewOrderHistory' },
      { path: '/order-to-approve', permission: 'orderApproval' },
      { path: '/report', permission: 'viewReporting' },
      { path: '/new-manpack-user', permission: 'addManpackUser' },
    ];

    // Check if the user has the required permissions for the requested path
    for (let map of mapping) {
      if (to.path.startsWith(map.path) && !permissions.includes(map.permission)) {
        return next('/'); // Redirect to homepage if no permission
      }
    }
  }

  // Allow access to public routes if the route starts with any public route path
  if (publicRoutes.some(path => to.path.startsWith(path))) {
    return next(); // Allow access to public routes
  }

  // If the user is not logged in and trying to access a restricted route
  if (!loggedIn) {
    return next(`/login?redirect=${encodeURIComponent(to.fullPath)}`); // Redirect to login with redirect query
  }

  // Proceed to the requested route
  next();
}
